export function isIrradianceInvalidationSuppressed() {
  return (
    typeof window !== "undefined" &&
    window.__suppressIrradianceInvalidation === true
  );
}

export function notifyIrradianceNeedsRecompute(reason = "scene-change") {
  if (isIrradianceInvalidationSuppressed()) return;
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("SEGMENT_GEOMETRY_CHANGED", {
      detail: {
        affectsAll: true,
        reason,
      },
    })
  );
}
